import { useState } from 'react';
import { ProjectTypes } from '../../utils/constants';

export default function GetShowProjectData({ dados, projectType, ...props }) {
  const [listinverters] = useState(dados?.data?.inverters || []);

  const getBreakerValue = () => {
    if (dados.data?.breaker_value === 'Outro' && dados.data?.other_breaker_value) {
      return dados.data?.other_breaker_value;
    }

    return dados.data?.breaker_value || '-';
  }

  const getProjectStructure = () => {
    switch (projectType) {
      case ProjectTypes.SOLAR_ENERGY:
        return (
          <>
            <h4>Informações da Instalação - Unidade Geradora</h4>
            <div className="div__oneRow">
              <p>
                <label>Disjuntor: </label> {dados.data?.breaker_type}
              </p>
              <p>
                <label>Valor: </label> {`${getBreakerValue()} A`}
              </p>
              <p>
                <label>Coordenadas: </label> {dados.latitude}, {dados.longitude}
              </p>
            </div>

            <h4>Especificações do Projeto</h4>

            <div className="div__oneRow">
              <p>
                <label>Potência Total do Projeto: </label>{' '}
                {dados?.data?.total_project_power} kWP
              </p>
            </div>
            {dados?.data?.amount_panels &&
              dados?.data?.panel_power &&
              dados?.data?.panel_model && (
                <div className="div__oneRow">
                  <p>
                    <label>Qtd. de Placas: </label>{' '}
                    {dados?.data?.amount_panels ?? 'Nenhuma'}
                  </p>
                  <p>
                    <label>Potência: </label>{' '}
                    {dados?.data?.panel_power
                      ? `${dados?.data?.panel_power} KWP`
                      : 'Nenhuma'}
                  </p>
                  <p>
                    <label>Modelo: </label>{' '}
                    {dados?.data?.panel_model ?? 'Nenhum'}
                  </p>
                </div>
              )}
            <br />

            {listinverters.length > 0 ? (
              listinverters?.map((inverter) => (
                <fieldset
                  key={inverter.id}
                  style={{ marginBottom: '1rem' }}
                  className="div__oneRow"
                >
                  <p>
                    <label>Qtd. de Inversores: </label> {inverter.amount}
                  </p>
                  <p>
                    <label>Potência: </label> {inverter.power_kwp} kWP
                  </p>
                  <p>
                    <label>Modelo: </label> {inverter.model}
                  </p>
                </fieldset>
              ))
            ) : (
              <div className="div__nada">Nenhum inversor cadastrado</div>
            )}
          </>
        );
      case ProjectTypes.AIR_SUBSTATION:
        return (
          <>
            <h4>Especificações do Projeto</h4>
            <div className="div__oneRow">
              <p>
                <label>Potência do transformador existente: </label>{' '}
                {dados?.data?.existing_transformer_power ?? '-'}
              </p>
              <p>
                <label>Nova potência do transformador:</label>{' '}
                {dados?.data?.new_transformer_power ?? '-'}{' '}
              </p>
              <p>
                <label>Coordenadas: </label> {dados?.latitude.slice(0, 10)},{' '}
                {dados?.longitude.slice(0, 10)}
              </p>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return getProjectStructure();
}
